import styled from "styled-components";
import { Row } from "uikit";

const Root = styled(Row)`
	height: 18.56px;
	cursor: pointer;
`;

export default Root;
